"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IBoundaryConfigurationSerialized.js.map